import {createContext} from "react"
import {Product, ProductVersion} from "@/library/api/models/changelog"

export type ChangelogContextData = {
    currentProduct?: Product
    products: Product[]
    versions: ProductVersion[]
    isLoading: boolean
    withAuth?: boolean
    selectProduct: (refKey: string) => void
}

export const ChangelogContext = createContext<ChangelogContextData>({
    currentProduct: undefined,
    products: [],
    versions: [],
    isLoading: true,
    withAuth: undefined,
    selectProduct: () => {
        throw new Error("No selectProduct() was provided...")
    }
})
